/* lua.js generated code 0.3.0 */

require("clover/panel/base/BasePanel")
require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
require("clover/data/ReplayManager")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var AlertDialog = xClass("AlertDialog", BasePanel, function () {
    // WARN: maybe multi result
    // return cc.CSLoader.createNode("cocos/new_user_reward_panel_newRewardPanel.csb")
    return cc.Node.create()
})
var DIALOG_WIDTH = 550
var BTN_HEIGHT = 100
var MARGIN_X = 50
var MARGIN_Y = 35
var BTN_MARGIN = 70

AlertDialog.isReady = function() {
    let bg = cc.loader.getRes('uilibrary/toast_bg.png')
    return !!bg
}

AlertDialog.prototype.ctor = function (params, okCallback, cancelCallback) {
    var self = this
    BasePanel.prototype.init.call(self)

    self.params = params;

    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/toast_bg.png")
    bg.setAnchorPoint(0.5, 0.5)
    self.addChild(bg)


    var btnWidth = DIALOG_WIDTH / 2 - 60
    var btnPosY = BTN_MARGIN

    var btnCount = 0
    if (params.needOkBtn) {
        btnCount++
    }
    if (params.needCancelBtn) {
        btnCount++
    }

    // 确认按钮
    if (params.needOkBtn) {
        var okBtn = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/b_green_cut.png")
        okBtn.setContentSize(cc.size(btnWidth, BTN_HEIGHT))

        // 水平位置
        var posX
        if (btnCount == 1) {
            posX = DIALOG_WIDTH / 2
        } else {
            posX = DIALOG_WIDTH / 4 + 12
        }
        okBtn.setPosition(posX, btnPosY)
        bg.addChild(okBtn)

        var okLabel = cc.Label.createWithSystemFont(params.okBtnText || "", "Arial", 30, 400)
        okLabel.setAnchorPoint(0.5, 0.43)
        okLabel._setFontWeight("bold")
        okLabel.setPosition(okBtn._getWidth() / 2, okBtn._getHeight() / 2 + 8)
        okBtn.addChild(okLabel)

        var uiButton = UIButton.create(okBtn, true)
        uiButton.on(UIButtonEvent.Click, function () {
            if (okCallback) {
                okCallback()
            }
            self.onClose()

        })
        ButtonPushBounceAnim.create(uiButton)
    }

    // 取消按钮
    if (params.needCancelBtn) {
        var cancelBtn = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/b_orange_cut.png")
        cancelBtn.setContentSize(cc.size(btnWidth, BTN_HEIGHT))
        // 水平位置
        var posX
        if (btnCount == 1) {
            posX = DIALOG_WIDTH / 2
        } else {
            posX = DIALOG_WIDTH * 3 / 4 - 12
        }
        cancelBtn.setPosition(posX, btnPosY)
        bg.addChild(cancelBtn)
        var cancelLabel = cc.Label.createWithSystemFont(params.cancelBtnText || "", "Arial", 30, 400)
        cancelLabel._setFontWeight("bold")
        cancelLabel.setAnchorPoint(0.5, 0.43)
        cancelLabel.setPosition(cancelBtn._getWidth() / 2, cancelBtn._getHeight() / 2 + 8)
        cancelBtn.addChild(cancelLabel)

        uiButton = UIButton.create(cancelBtn, true)
        uiButton.on(UIButtonEvent.Click, function () {
            if (cancelCallback) {
                cancelCallback()
            }
            self.onClose()
        })
        ButtonPushBounceAnim.create(uiButton)
    }

    // 正文
    var textTxt = params.text || ""
    var text = cc.Label.createWithSystemFont(params.text, "Arial", 30, 400)
    text.setDimensions(DIALOG_WIDTH - MARGIN_X * 2, 0)
    text.setTextColor(cc.color(180, 119, 59, 255))
    text.setAlignment(cc.TEXT_ALIGNMENT_LEFT)
    var textPosY = BTN_HEIGHT + MARGIN_Y + text.height / 2
    text.setPosition(DIALOG_WIDTH / 2, textPosY)
    text.setAnchorPoint(0.5, 0.5)
    bg.addChild(text)

    // 标题
    var title = params.title
    var titleHeight = 0
    if (title) {
        var titleLabel = cc.Label.createWithSystemFont(title, "Arial", 40, 400)
        titleLabel.setDimensions(DIALOG_WIDTH - MARGIN_X * 2, 0)
        titleHeight = titleLabel.height + MARGIN_Y / 2
        var titlePosY = text.height + BTN_HEIGHT + MARGIN_Y * 2
        titleLabel.setTextColor(cc.color(180, 119, 59, 255))
        titleLabel._setFontWeight("bold")
        titleLabel.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
        titleLabel.setAnchorPoint(cc.p(0.5, 0.5))
        titleLabel.setPosition(DIALOG_WIDTH / 2, titlePosY)
        bg.addChild(titleLabel)
    }

    var bgHeight = titleHeight + text.height + BTN_HEIGHT + MARGIN_Y * 2
    bg.setContentSize(cc.size(DIALOG_WIDTH, bgHeight))

}

AlertDialog.prototype.onEnter = function () {
    var self = this
    BasePanel.prototype.onEnter.call(self)
}

AlertDialog.prototype.onCleanup = function () {
    var self = this;
    if (self.params.cleanupCb){
        self.params.cleanupCb();
    }
    
}
module.exports = AlertDialog
